import Seo from "@/components/seo/Seo"

import SolutionsHero from "@/components/sections/solutions/SolutionsHero"
import SolutionsGrid from "@/components/sections/solutions/SolutionsGrid"
import SolutionsTrust from "@/components/sections/solutions/SolutionsTrust"
import SolutionsFAQ from "@/components/sections/solutions/SolutionsFAQ"
import SolutionsProcess from "@/components/sections/solutions/SolutionsProcess"
import SolutionsExperience from "@/components/sections/solutions/SolutionsExperience"

import SectionReveal from "@/components/common/SectionReveal"

export default function Solutions() {
  return (
    <>
      <Seo
        title="Airbnb Management Solutions | Zenia Stays"
        description="End-to-end Airbnb and short-term rental management solutions including pricing optimization, guest communication, operations, and listing management."
        canonical="https://zeniastays.com/solutions"
      />

      <SolutionsHero />

      <SectionReveal>
        <SolutionsGrid />
      </SectionReveal>

      <SectionReveal delay={0.05}>
        <SolutionsTrust />
      </SectionReveal>

      <SectionReveal delay={0.08}>
        <SolutionsExperience />
      </SectionReveal>

      <SectionReveal delay={0.1}>
        <SolutionsProcess />
      </SectionReveal>

      <SectionReveal delay={0.12}>
        <SolutionsFAQ />
      </SectionReveal>

    </>
  )
}